// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".field-label[data-v-2603e4d4]{color:#90a4ae;word-break:break-all;width:100%;font-size:.8em;margin-bottom:.5em}.field-value[data-v-2603e4d4]{word-break:break-all;font-size:1.1em;color:#31393c;margin-bottom:14px}.blue-highlight[data-v-2603e4d4]{color:#0094fb}.img-container[data-v-2603e4d4],.img-container img[data-v-2603e4d4]{width:100%}", ""]);
// Exports
module.exports = exports;
